export const STATUS_URL = 'https://bolago.statuspage.io/api/v2/status.json';
export const MAINTENANCE_URL = 'https://bolago.statuspage.io/api/v2/scheduled-maintenances.json';
export const STATUS_INTERVAL_TIME = 30 * 1000;
